let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jYr96")).then(() => parcelRequire('1cgZV'));